module.exports = __webpack_public_path__ + "img/8S.603b84d2.png";